module.exports = __webpack_public_path__ + "static/relaztheback-e6069fa8ef4082586020c0e46017b5ba.jpg";